import { parseISO, format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import api from '../../../services/api';

const EMPTY_LIST = [];

const withDataExame = list =>
  (list || EMPTY_LIST).map((lab, index) => ({
    ...lab,
    dataExame: format(parseISO(lab.DATALABOR), 'dd/MM/yyyy', {
      locale: pt,
    }),
    counter: index + 1,
  }));

export const examesLabKey = (codPac, codConsulta) => [
  'exameslab',
  codPac,
  codConsulta,
];
export const viewExamesKey = codPac => ['viewexames', codPac];
export const viewLabResultsKey = codPac => ['viewlabresults', codPac];
export const tabelaExamesKey = codPac => ['tabelaexames', codPac];

export const fetchExamesLab = async (codPac, codConsulta) => {
  const result = await api.get('/exameslab', {
    params: { CODPAC: codPac, CODCONSULTA: codConsulta },
  });
  return result.data || EMPTY_LIST;
};

export const fetchViewExames = async codPac => {
  const { data } = await api.get('/viewexames', {
    params: { CODPAC: codPac },
  });
  return data || EMPTY_LIST;
};

export const fetchViewLabResults = async codPac => {
  const response = await api.get('/viewlabresults', {
    params: { CODPAC: codPac },
  });
  return withDataExame(response.data);
};

export const fetchTabelaExames = async codPac => {
  const result = await api.get('/tabelaexames', {
    params: { CODPAC: codPac },
  });
  return withDataExame(result.data);
};

export const LAB_SWR_KEY_PREFIXES = [
  'exameslab',
  'viewexames',
  'viewlabresults',
  'tabelaexames',
];
